// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.75 4.33594V11.3359L5.75 4.33594V19.6644L12.75 12.6644V19.6644L20.4142 12.0002L12.75 4.33594Z"}}]};

const ForwardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'forward-filled',
    ref,
    icon: element,
  },
));

ForwardFilledIcon.displayName = 'ForwardFilledIcon';

export default ForwardFilledIcon;
